export const queryKeys = {
  GET_ACCOUNT_NUMBERS: 'GET_ACCOUNT_NUMBERS'
};
